import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal, NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { CourseService } from '../services/course.service';
import { ShareService } from '../services/share.service';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { HeaderService } from '../services/header.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-subscribed-courses',
  templateUrl: './subscribed-courses.component.html',
  styleUrls: ['./subscribed-courses.component.scss']
})
export class SubscribedCoursesComponent implements OnInit {

  constructor(private modalService: NgbModal, private courseService: CourseService, private shareService: ShareService, rateConfig: NgbRatingConfig, private router: Router, private ns: NotificationService, private headerService: HeaderService) { }
  role='';
  course_list = [];
  total_pages;
  current_page:any = 1;
  number_of_page
  totalLengthU:any

  loader = false;
  sortBy: string = 'subscribed_course';
  sortingList: any[] = [{ id: 1, name: 'Subscribed Course', value: 'subscribed_course' }, { id: 2, name: 'Completed Course', value: 'archieved_course' }];
  get permissions() {
    return JSON.parse(localStorage.getItem("permissions"));
  }
  orgSubDomain: string = '';
  heroCopyKey: 'default' | 'isdm' = 'default';
  private orgLogoSub?: Subscription;
  private heroCopyMap = {
    default: {
      title: 'Learn without limits',
      body: [
        'Explore new skills, deepen existing passions, and get lost in learning.',
        'What you find just might surprise and inspire you.'
      ]
    },
    isdm: {
      title: 'Welcome to the Data Science Exchange.',
      body: ['Together, let’s build solutions that matter.']
    }
  };

  ngOnInit() {
    this.role = localStorage.getItem('role');
    this.sortBy === 'subscribed_course' ? this.getSubscribedCourses(1)  : this.getArchievedCourses(1) ;
    this.orgLogoSub = this.headerService.orgLogo.subscribe((logoData: any) => {
      const organizationSubDomain = logoData && logoData.organizationSubDomain ? logoData.organizationSubDomain : '';
      this.orgSubDomain = organizationSubDomain;
      this.heroCopyKey = organizationSubDomain.toLowerCase() === 'isdm' ? 'isdm' : 'default';
    });
  }

getSubscribedCourses(page) {
    this.course_list = []
    this.loader = true
    this.courseService.subscribedCourses(page).subscribe(get_list => {
    this.course_list = get_list.response.data;
    this.totalLengthU = get_list.response.total_items
    this.loader = false;
    }, err => {
    this.loader = false;
      console.log(err);
    });

  }

  getArchievedCourses(page){
    this.course_list=[]
    this.loader = true
    this.course_list = [];
    this.courseService.deactivated_course(page).subscribe(get_list=> {
      this.course_list = get_list.response.data; 
      this.totalLengthU = get_list.response.total_items
      this.loader = false;
    },
    (err)=> {
      this.loader=false
      console.log(err);
    })
 
  }
currentPageNo(page){
  this.current_page = page;
  this.sortBy === 'subscribed_course' ? this.getSubscribedCourses(page)  : this.getArchievedCourses(page) ;
  
}

  onSortData(event){
    this.sortBy = event.target.value;
    this.current_page = 1;
    this.sortBy === 'subscribed_course' ? this.getSubscribedCourses(1)  : this.getArchievedCourses(1) ;
  }



  //show course details page
  sendCourseDetails(id, course) {
    this.router.navigate(['/courses/single-course'], { queryParams: { course_id: id, course: course, tab_no: 1 } });
  }

  ngOnDestroy() {
    if (this.orgLogoSub) {
      this.orgLogoSub.unsubscribe();
    }
  }

  get heroCopy() {
    return this.heroCopyMap[this.heroCopyKey];
  }


}
